import { cartBus } from '@/event/cartBus'
import { isNavbarVisible } from '@/event/isNavbarVisible'
import { sectionOrderBus } from '@/event/sectionOrderBus'
import { applyTheme, VALID_THEMES, VALID_THEMES_HAPPY } from '@/event/theme/theme'
import { baseUrl } from '@/event/url/url'
import stores from '@/storage/stores'
import { showSectionManagement } from '@/event/main/app/showSectionManagement'
import { urlGetStore } from '@/api/endpoint'
import { logoHome, logoHomeAlt } from '@/event/setting/logoHome'
import { injectCaptchaScript } from './captcha/injectCaptchaScript'
import { fetchPostAuthorizationCsrf } from './fetch/fetchPostAuthorizationCsrf'
import bannerHappy from '@/happyTheme/storage/bannerHappy'
import { applyCardTheme } from '@/event/theme/card'
import { initLocale, getInitialLanguageId } from '@/event/locale'


export async function getStore() {
  try {
    const data = { url: baseUrl, language_id: getInitialLanguageId() }

    const response = await fetchPostAuthorizationCsrf(urlGetStore, data)

    const nonce = response.data.nonce

    injectCaptchaScript(nonce)

    if (response.class === 'success') {
      const storeData = response.data

      logoHome.value =
        storeData.setting?.find((s: { key: string }) => s.key === 'config_logo')?.value ?? null
      logoHomeAlt.value = logoHome.value?.split('/').pop()?.split('.').shift() ?? 'logo'

      if (storeData && !storeData.banner_images) {
        isNavbarVisible.value = true
        if (cartBus.value.length > 0) {
          sectionOrderBus.value = true
        }
      }

      if (storeData && storeData.setting) {
        let configMaintenance = storeData.setting.find(
          (setting: { key: string }) => setting.key === 'config_maintenance'
        )

        if (!configMaintenance) {
          configMaintenance = { key: 'config_maintenance', value: '0' }
          storeData.setting.push(configMaintenance)
        }

        if (configMaintenance.value === '1') {
          showSectionManagement.value = true
        }

        const openingHoursSetting = storeData.setting.find(
          (setting: { key: string }) => setting.key === 'config_opening_hours'
        )

        if (
          openingHoursSetting &&
          typeof openingHoursSetting.value === 'string' &&
          openingHoursSetting.value.length > 0
        ) {
          const openingHoursString = openingHoursSetting.value
          const openingHoursJson = JSON.parse(openingHoursString)
          if (openingHoursJson) {
            storeData.setting.find(
              (setting: { key: string }) => setting.key === 'config_opening_hours'
            ).value = openingHoursJson
          }
        }

        const deliveryZonesSetting = storeData.setting.find(
          (setting: { key: string }) => setting.key === 'config_delivery_zones'
        )
        if (
          deliveryZonesSetting &&
          typeof deliveryZonesSetting.value === 'string' &&
          deliveryZonesSetting.value.length > 0
        ) {
          const deliveryZonesJson = JSON.parse(deliveryZonesSetting.value)
          if (deliveryZonesJson) {
            storeData.setting.find(
              (setting: { key: string }) => setting.key === 'config_delivery_zones'
            ).value = deliveryZonesJson
          }
        }

        const deliveryTimeSettings = storeData.setting.find(
          (setting: { key: string }) => setting.key === 'config_delivery_time_settings'
        )

        if (
          deliveryTimeSettings &&
          typeof deliveryTimeSettings.value === 'string' &&
          deliveryTimeSettings.value.length > 0
        ) {
          const deliveryTimeSettingsJson = JSON.parse(deliveryTimeSettings.value)
          if (deliveryTimeSettingsJson) {
            storeData.setting.find(
              (setting: { key: string }) => setting.key === 'config_delivery_time_settings'
            ).value = deliveryTimeSettingsJson
          }
        }

        const configAreas = storeData.setting.find(
          (setting: { key: string }) => setting.key === 'config_areas'
        )

        if (configAreas && typeof configAreas.value === 'string' && configAreas.value.length > 0) {
          const configAreasJson = JSON.parse(configAreas.value)
          if (configAreasJson) {
            storeData.setting.find(
              (setting: { key: string }) => setting.key === 'config_areas'
            ).value = configAreasJson
          }
        }
      }

      if (storeData && storeData.config) {
        const newStoreConfig = JSON.parse(storeData.config)
        storeData.config = newStoreConfig
      }

      stores.setStoresData(storeData)

      // Initialize language and currency from backend settings
      if (storeData.setting) {
        initLocale(storeData.setting, storeData)
      }

      if (stores.getStoresData().setting?.find((s: { key: string }) => s.key === 'config_theme')) {
        const themeSetting = stores
          .getStoresData()
          .setting?.find((s: { key: string }) => s.key === 'config_theme').value

        if (VALID_THEMES) {
          bannerHappy.setBannerData(storeData.banner_images)
        }

        if (VALID_THEMES_HAPPY.includes(themeSetting)) {
          const themeLS = localStorage.getItem('theme')
          if (themeLS === 'happy-light' || themeLS === 'happy-dark') {
            applyTheme(themeLS)
          } else {
            applyTheme(themeSetting)
          }
        } else {
          applyTheme(themeSetting)
        }
      }

      if (stores.getStoresData().setting?.find((s: { key: string }) => s.key === 'config_card')) {
        const cardSetting = stores.getStoresData().setting?.find(
          (s: { key: string }) => s.key === 'config_card'
        )

        if (cardSetting) {
          applyCardTheme(cardSetting.value)
        }
      }
    } else {
    }
  } catch (e) {
  }
}